<template>
  <div>
    <!-- Глобальный индикатор загрузки -->
    <div v-if="isLoading && !hasVisibleMtsPopup" class="global-loading-overlay">
      <div class="loading-indicator">
        <div class="loader"></div>
        <p>Загрузка данных...</p>
      </div>
    </div>

    <div class="buymodal-block__body">
      <div class="body-info">
        <div class="body-info__title">
          Ввод данных клиента
        </div>
        <div class="body-info__block">
          <div class="info-user">
            <div class="info-user__line">
              <input
                type="text"
                v-model.trim="lastname"
                required
                id="lastname"
                class="inpt"
                :class="lastname ? 'active' : ''"
                :readonly="user.flowType === 'mts' && model.client && model.client.name" />
              <label
                for="lastname"
                class="label">
                Фамилия
              </label>
              <span
                v-if="errors.lastname"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div class="info-user__line">
              <input
                type="text"
                v-model.trim="firstname"
                required
                id="firstname"
                class="inpt"
                :class="firstname ? 'active' : ''"
                :readonly="user.flowType === 'mts' && model.client && model.client.name" />
              <label
                for="firstname"
                class="label">
                Имя
              </label>
              <span
                v-if="errors.firstname"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div class="info-user__line">
              <input
                type="text"
                v-model.trim="patronymic"
                required
                id="patronymic"
                class="inpt"
                :class="patronymic ? 'active' : ''"
                :readonly="user.flowType === 'mts' && model.client && model.client.name" />
              <label
                for="patronymic"
                class="label">
                Отчество (при наличии)
              </label>
            </div>
            <div class="info-user__line">
              <input
                class="inpt"
                v-model.trim="telefon"
                v-mask="phoneNumberMask"
                id="telefon"
                :class="telefon ? 'active' : ''"
                :readonly="user.flowType === 'mts' && model.client && model.client.name" />
              <label
                for="telefon"
                class="label">
                Номер телефона
              </label>
              <span
                v-if="errors.telefon"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div class="info-user__line" v-if="user.flowType == 'mts'">
              <input
                type="text"
                v-model.trim="passport_serial"
                required
                id="passport_serial"
                class="inpt"
                :class="passport_serial ? 'active' : ''"
                :readonly="user.flowType === 'mts' && model.client && model.client.name" />
              <label
                for="passport_serial"
                class="label">
                Серия паспорта
              </label>
            </div>
            <div class="info-user__line"  v-if="user.flowType == 'mts'">
              <input
                type="text"
                v-model.trim="passport_number"
                required
                id="passport_number"
                class="inpt"
                :class="passport_number ? 'active' : ''"
                :readonly="user.flowType === 'mts' && model.client && model.client.name" />
              <label
                for="passport_number"
                class="label">
                Номер паспорта
              </label>
            </div>
            <!-- <div
              v-if="user.flowType === 'mts'"
              class="info-user__line half">
              <input
                type="text"
                v-model.trim="email"
                v-mask="cardNumberMask"
                required
                id="email"
                class="inpt"
                :class="email ? 'active' : ''"
                :readonly="user.flowType === 'mts' && model.client && model.client.name" />
              <label
                for="email"
                class="label">
                Номер карты для выплаты
              </label>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Показываем соответствующий футер на основе flowType и состояния -->
    <div v-if="user.flowType === 'mts' && model.client && model.client.name" class="buymodal-block__footer">
      <button 
        type="button" 
        class="btn cancel" 
        @click.prevent="reportMtsDataError">
        Ошибка
      </button>
      <button 
        type="button" 
        class="btn next" 
        @click.prevent="handleMtsConfirmDataClick">
        Подтвердить данные
      </button>
    </div>
    <div v-else class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="next()">
        Продолжить
      </button>
    </div>

    <!-- Popup для ввода телефона MTS -->
    <div class="popup-overlay" v-if="mtsPhonePopupVisible">
      <div class="popup-container">
        <div class="popup-header">
          <h3>Подтверждение номера телефона</h3>
        </div>
        <!-- Используем :key для принудительного обновления содержимого -->
        <div class="popup-body" :key="mtsSmsLinkSent ? 'sent' : 'form'">
          <template v-if="!mtsSmsLinkSent">
            <p>Клиент должен подписать договор на личном устройстве, для этого ему будет направлено смс с ссылкой для подписания. Проверьте номер телефона</p>
            <div class="form-group">
              <label for="mtsPhoneInput">Номер телефона</label>
              <input 
                type="text" 
                id="mtsPhoneInput" 
                v-model="mtsPhoneNumber" 
                v-mask="'+# (###) ###-##-##'"
                placeholder="+_ (___) ___-__-__"
                class="form-control"
              />
            </div>
          </template>
          <template v-else>
            <p>Ссылка отправлена, клиент заполняет данные.</p>
            <p>Обновление данных через {{ mtsPhoneCountdown }} секунд</p>
          </template>
          
          <!-- Индикатор загрузки -->
          <div v-if="isLoading" class="loading-indicator">
            <div class="loader"></div>
            <p>Пожалуйста, подождите...</p>
          </div>
        </div>
        <!-- Используем :key для принудительного обновления кнопок -->
        <div class="popup-footer" :key="mtsSmsLinkSent ? 'sent-btn' : 'form-btn'">
          <template v-if="!mtsSmsLinkSent">
            <button class="btn next" @click="sendMtsSmsLink" :disabled="isLoading">
              Отправить ссылку
            </button>
          </template>
          <template v-else>
            <button class="btn cancel" @click="resetMtsPhonePopup" :disabled="isLoading">
              Отправить СМС повторно
            </button>
          </template>
        </div>
      </div>
    </div>

    <div class="popup-overlay" v-if="mtsPassportMatchPopupVisible">
      <div class="popup-container">
        <div class="popup-header">
          <h3>Проверка паспортных данных</h3>
        </div>
        <div class="popup-body">
          <p>Требуется проверить данные в системе и в паспорте клиента, в случае несовпадения требуется отменить заявку.</p>
        </div>
        <div class="popup-footer">
          <button class="btn next" @click="closeMtsPassportMatchPopup">
            Да, я проверю
          </button>
        </div>
      </div>
    </div>

    <div class="popup-overlay" v-if="mtsPassportFinalCheckPopupVisible">
      <div class="popup-container">
        <div class="popup-header">
          <h3>Подтверждение проверки</h3>
        </div>
        <div class="popup-body">
          <p>Я проверил паспортные данные клиента и они совпадают.</p>
        </div>
        <div class="popup-footer">
          <button class="btn cancel" @click="returnToMtsDataCheck" :disabled="isLoading">
            Вернуться и проверить
          </button>
          <button class="btn next" @click="confirmMtsPassportChecked" :disabled="isLoading">
            Я все проверил
          </button>
        </div>
      </div>
    </div>

    <div class="popup-overlay" v-if="mtsDataResetPopupVisible">
      <div class="popup-container">
        <div class="popup-header">
          <h3>Повторное заполнение данных</h3>
        </div>
        <div class="popup-body">
          <p>Данные клиента и текущая подпись станут неактуальны. Клиенту потребуется заново заполнить данные и подписать договор.</p>
        </div>
        <div class="popup-footer">
          <button class="btn cancel" @click="closeMtsDataResetPopup" :disabled="isLoading">
            Отмена
          </button>
          <button class="btn next" @click="confirmMtsDataReset" :disabled="isLoading">
            Заполнить повторно
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      lastname: '',
      firstname: '',
      patronymic: '',
      telefon: '',
      email: '',
      passport_number: '',
      passport_serial: '',
      errors: {
        lastname: false,
        firstname: false,
        telefon: false
      },
      mtsPhonePopupVisible: false,
      mtsPhoneNumber: '',
      mtsPhoneTimer: null,
      mtsPhoneCountdown: 0,
      mtsSmsLinkSent: false,
      mtsPassportMatchPopupVisible: false,
      mtsPassportFinalCheckPopupVisible: false,
      mtsPassportMatchPopupShown: false,
      mtsDataResetPopupVisible: false,
      isLoading: false // Добавляем индикатор загрузки
    }
  },
  computed: {
    ...mapState('buyphones', ['model','clientInfo', 'orderStatus']),
    ...mapState('user', ['user']),
    isMtsContractSigned() {
      return this.model && this.model.signed === true;
    },
    isMtsClientDataReady() {
      return this.user.flowType === 'mts'
        && this.isMtsContractSigned
        && this.model
        && this.model.client
        && this.model.client.name;
    },
    hasVisibleMtsPopup() {
      return this.mtsPhonePopupVisible
        || this.mtsPassportMatchPopupVisible
        || this.mtsPassportFinalCheckPopupVisible
        || this.mtsDataResetPopupVisible;
    },
  },
  mounted() {
    console.log('Начальное состояние:', {
      mtsSmsLinkSent: this.mtsSmsLinkSent,
      mtsPhonePopupVisible: this.mtsPhonePopupVisible
    });
    
    if (this.clientInfo) {
      this.lastname = this.clientInfo.lastname;
      this.firstname = this.clientInfo.firstname;
      this.patronymic = this.clientInfo.patronymic;
      this.telefon = this.clientInfo.telefon;
      this.email = this.clientInfo.email;
      this.passport_number = this.clientInfo.passport_number;
      this.passport_serial = this.clientInfo.passport_serial;
    }

    // Если это поток MTS
    if (this.user.flowType === 'mts') {
      // Включаем индикатор загрузки сразу
      this.isLoading = true;
      
      // Получаем актуальные данные о заказе
      this.getOrder({ btag: this.model.btag, loader: false })
        .then(() => {
          // Заполняем данные из модели, если они там есть
          if (this.model && this.model.client) {
            if (this.model.client.name) {
              const nameParts = this.model.client.name.split(' ');
              if (nameParts.length >= 2) {
                this.lastname = nameParts[0] || '';
                this.firstname = nameParts[1] || '';
                this.patronymic = nameParts.slice(2).join(' ') || '';
              }
              
              // Правильно получаем паспортные данные из модели
              if (this.model.client.passport_serial) {
                this.passport_serial = this.model.client.passport_serial;
              } else if (this.clientInfo && this.clientInfo.passport_serial) {
                this.passport_serial = this.clientInfo.passport_serial;
              }
              
              if (this.model.client.passport_number) {
                this.passport_number = this.model.client.passport_number;
              } else if (this.clientInfo && this.clientInfo.passport_number) {
                this.passport_number = this.clientInfo.passport_number;
              }
              
              if (this.isMtsClientDataReady) {
                this.isLoading = false;
                this.showMtsPassportMatchPopup();
                return;
              }
            }
            
            if (this.model.client.phone) {
              // Форматируем телефон для отображения
              this.telefon = this.formatPhoneForDisplay(this.model.client.phone);
              this.mtsPhoneNumber = this.formatPhoneForDisplay(this.model.client.phone);
            }
            if (this.model.client.email) {
              this.email = this.model.client.email;
            }
          }
          
          // Убедимся, что скрываем индикатор загрузки только после завершения всей обработки
          setTimeout(() => {
            this.isLoading = false;
            // Если договор еще не подписан или у него отсутствует имя клиента, показываем попап для ввода телефона
            if (!this.isMtsClientDataReady) {
              this.showMtsPhonePopup();
            }
          }, 300); // Небольшая задержка для плавности UI
        })
        .catch(error => {
          console.error('Ошибка при получении данных заказа:', error);
          this.isLoading = false;
          this.setError('Ошибка при получении данных заказа');
        });
    }
  },
  watch: {
    clientInfo(data) {
      if (data) {
        this.lastname = data.lastname;
        this.firstname = data.firstname;
        this.patronymic = data.patronymic;
        this.telefon = data.telefon;
        this.email = data.email;
      }
    },
    'model.client': {
      handler(newClient) {
        if (this.isMtsClientDataReady) {
          // Клиент заполнил данные, закрываем попап если он открыт
          console.log('Клиент заполнил данные, закрываем попап');
          console.log(this.mtsPhonePopupVisible)
          if (this.mtsPhonePopupVisible) {
            this.closeMtsPhonePopup();
          }
          
          // Заполняем поля данными из модели
          const nameParts = newClient.name.split(' ');
          if (nameParts.length >= 2) {
            this.lastname = nameParts[0] || '';
            this.firstname = nameParts[1] || '';
            this.patronymic = nameParts.slice(2).join(' ') || '';
          }
          
          // Проверяем паспортные данные в newClient и обновляем их
          if (newClient.passport_serial) {
            this.passport_serial = newClient.passport_serial;
          } else if (this.clientInfo && this.clientInfo.passport_serial) {
            this.passport_serial = this.clientInfo.passport_serial;
          }
          
          if (newClient.passport_number) {
            this.passport_number = newClient.passport_number;
          } else if (this.clientInfo && this.clientInfo.passport_number) {
            this.passport_number = this.clientInfo.passport_number;
          }
          
          if (newClient.phone) {
            this.telefon = this.formatPhoneForDisplay(newClient.phone);
          }
          
          if (newClient.email) {
            this.email = newClient.email;
          }
          
          // Обновляем clientInfo в store со всеми полями
          this.CHANGE_CLIENT_INFO({
            lastname: this.lastname,
            firstname: this.firstname,
            patronymic: this.patronymic,
            passport_number: this.passport_number,
            passport_serial: this.passport_serial,
            telefon: this.telefon,
            email: this.email
          });

          this.showMtsPassportMatchPopup();
        }
      },
      deep: true
    },
    lastname() {
      this.errors.lastname = false;
    },
    firstname() {
      this.errors.firstname = false;
    },
    telefon() {
      this.errors.telefon = false;
    },
  },
  methods: {
    ...mapMutations('buyphones', ['CHANGE_CLIENT_INFO', 'CHANGE_SCREEN_THREE']),
    ...mapActions('buyphones', [
      'updateOrder', 
      'sendSms', 
      'getOrder', 
      'setError',
      'sendUserAccountLink',
      'reportUserAccountError',
      'markContractReady'
    ]),

    phoneNumberMask(value) {
      if(value.includes("+99 (6") || value.includes("+99 (8") || value.includes("+996") || value.includes("+998") || value.includes("+9 (96") || value.includes("+9 (98")){
        return ['+',/\d/,/\d/,/\d/, ' ','(', /\d/, /\d/, /\d/, ')',' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/,/\d/];
      }
      var code = [/\d/];
      if (value.length == 19){
        code = [/\d/,/\d/];
      }else if (value.length >= 20){
        code = [/\d/,/\d/,/\d/];
      }
      return ['+'].concat(code, [' ','(', /\d/, /\d/, /\d/, ')',' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/,'-',/\d/, /\d/]);
    },
    
    cardNumberMask() {
      return [/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/];
    },
    
    async next() {
      if (this.lastname == '') {
        this.errors.lastname = true;
        return false;
      }
      if (this.firstname == '') {
        this.errors.firstname = true;
        return false;
      }
      if (this.telefon == '') {
        this.errors.telefon = true;
        return false;
      }

      const user = {
        lastname: this.lastname,
        firstname: this.firstname,
        patronymic: this.patronymic,
        telefon: this.telefon,
        email: this.email
      }

      await this.CHANGE_CLIENT_INFO(user);

      // Нормализуем телефон для API (без +)
      const normalizedPhone = this.normalizePhoneNumber(this.clientInfo.telefon);
      
      await this.updateOrder({
        btag: this.model.btag,
        data: {
          client: {
            name: this.clientInfo.lastname + ' ' + this.clientInfo.firstname + ' ' + this.clientInfo.patronymic,
            phone: normalizedPhone,
            email: this.clientInfo.email,
          }
        }
      });

      var sendData = {
        "contractId": this.model.btag,
        "phoneNumber": this.clientInfo.telefon // Использовать полный номер с + для SMS
      }
      await this.sendSms(sendData)

      this.CHANGE_SCREEN_THREE({ show2: false, show3: false, show4: true });
    },
    
    async checkContractInfo() {
      // Запрашиваем данные о заказе
      console.log('Проверка информации о контракте MTS');
      await this.getOrder({ btag: this.model.btag, loader: false });
      
      // Если мы только что открыли экран и договор еще не подписан, показываем попап с телефоном
      if (!this.isMtsClientDataReady) {
         if (this.model && this.model.client && this.model.client.phone) {
          this.mtsPhoneNumber = '+' + this.model.client.phone;
        }
        this.showMtsPhonePopup();
      }
    },
    
    showMtsPhonePopup() {
      console.log('Показ попапа для ввода телефона MTS');
      this.mtsPhonePopupVisible = true;
      this.mtsSmsLinkSent = false;
    },
    
    // Обновленный метод sendMtsSmsLink
    async sendMtsSmsLink() {
      try {
        // Получаем только цифры из номера телефона
        const phoneWithoutFormatting = this.mtsPhoneNumber.replace(/\D/g, '');
        
        // Нормализуем номер для отправки API (только последние 10 цифр)
        const normalizedPhone = this.normalizePhoneNumber(phoneWithoutFormatting);
        
        // Проверяем валидность телефона
        if (normalizedPhone.length < 10) {
          this.setError('Введите корректный номер телефона');
          return;
        }
        
        console.log('Отправляем SMS на номер:', normalizedPhone);
        // Показываем индикатор загрузки
        this.isLoading = true;
        
        // Используем действие из Vuex с нормализованным номером
        const response = await this.sendUserAccountLink({
          btag: this.model.btag,
          phone: normalizedPhone
        });
        
        console.log('Получен ответ на отправку SMS:', response);
        
        // Более гибкая проверка ответа
        const isSuccess = response && (
          response.status === 'ok' || 
          response.success === true ||
          response.result === 'success'
        );
        
        // Скрываем индикатор загрузки перед обновлением UI
        this.isLoading = false;
        
        if (isSuccess) {
          // Обновляем телефон с правильным форматированием
          const formattedPhone = this.formatPhoneForDisplay(normalizedPhone);
          this.telefon = formattedPhone;
          this.mtsPhoneNumber = formattedPhone;
          
          this.CHANGE_CLIENT_INFO({
            ...this.clientInfo,
            telefon: formattedPhone
          });
          
          console.log('SMS отправлена успешно, запускаем таймер');
          
          // Важно! Используем $nextTick для гарантии обновления DOM
          this.$nextTick(() => {
            // Устанавливаем флаг и запускаем таймер только после обновления DOM
            this.mtsSmsLinkSent = true;
            this.mtsPhoneCountdown = 10;
            this.startMtsPolling();
            
            console.log('Флаг mtsSmsLinkSent установлен в:', this.mtsSmsLinkSent);
          });
        } else {
          // Более детальная обработка ошибки
          let errorMsg = 'Ошибка отправки SMS';
          if (response) {
            errorMsg = response.message || response.error || response.errorMessage || errorMsg;
          }
          this.setError(errorMsg);
        }
      } catch (error) {
        console.error('Ошибка при отправке SMS:', error);
        this.setError(error.message || 'Ошибка отправки SMS');
        // Скрываем индикатор загрузки в случае ошибки
        this.isLoading = false;
      }
    },
    
    startMtsPolling() {
      console.log('Запуск таймера опроса статуса. mtsSmsLinkSent =', this.mtsSmsLinkSent);
      
      // Очищаем существующий таймер, если он есть
      if (this.mtsPhoneTimer) {
        clearInterval(this.mtsPhoneTimer);
        this.mtsPhoneTimer = null;
      }
      
      // Еще раз проверяем, что флаг установлен правильно
      // Если по какой-то причине он не установлен, исправляем
      if (!this.mtsSmsLinkSent) {
        console.warn('mtsSmsLinkSent был false! Устанавливаем в true');
        this.mtsSmsLinkSent = true;
      }
      
      // Запускаем обратный отсчет
      this.mtsPhoneTimer = setInterval(() => {
        console.log('Таймер тикает, осталось секунд:', this.mtsPhoneCountdown);
        
        if (this.mtsPhoneCountdown > 0) {
          this.mtsPhoneCountdown--;
        } else {
          console.log('Время вышло, запрашиваем новые данные');
          // Запрашиваем обновленную информацию о заказе
          this.pollOrderStatus();
          this.mtsPhoneCountdown = 10; // Сбрасываем таймер
        }
      }, 1000);
    },
    
    async pollOrderStatus() {
      console.log('Опрос статуса заказа');
      
      try {
        // Показываем индикатор загрузки только в попапе
        this.isLoading = true;

        await this.getOrder({ btag: this.model.btag, loader: false });
        console.log('Получены данные заказа:', this.model.client);

        // Проверяем, заполнил ли клиент данные
        if (this.isMtsClientDataReady) {
          console.log('Клиент заполнил данные, закрываем попап');
          // Клиент заполнил данные, закрываем попап
          this.closeMtsPhonePopup();
          this.showMtsPassportMatchPopup();
        } else {
          console.log('Клиент еще не заполнил данные, продолжаем опрос');
        }
      } catch (error) {
        console.error('Ошибка при получении данных заказа:', error);
      } finally {
        this.isLoading = false;
      }
    },
    
    closeMtsPhonePopup() {
      console.log('Закрытие попапа');
      console.log('mtsPhonePopupVisible перед закрытием:', this.mtsPhonePopupVisible);
      console.log(this.orderStatus, this.model, this.model.client, this.model.client.name);
      if (this.isMtsClientDataReady) {
        this.mtsPhonePopupVisible = false;
        if (this.mtsPhoneTimer) {
          clearInterval(this.mtsPhoneTimer);
          this.mtsPhoneTimer = null;
        }
      }

      
    },

    showMtsPassportMatchPopup() {
      if (!this.isMtsClientDataReady || this.mtsPassportMatchPopupShown) {
        return;
      }

      this.mtsPassportMatchPopupVisible = true;
      this.mtsPassportMatchPopupShown = true;
    },

    closeMtsPassportMatchPopup() {
      this.mtsPassportMatchPopupVisible = false;
    },

    handleMtsConfirmDataClick() {
      this.mtsPassportFinalCheckPopupVisible = true;
    },

    returnToMtsDataCheck() {
      this.mtsPassportFinalCheckPopupVisible = false;
    },

    async confirmMtsPassportChecked() {
      try {
        this.isLoading = true;

        await this.markContractReady({
          btag: this.model.btag
        });

        this.mtsPassportFinalCheckPopupVisible = false;
        this.$emit('changeScreen', {type: 'next', id: 2});
      } catch (error) {
        console.error('Ошибка при подтверждении готовности договора MTS:', error);
        this.setError('Ошибка при подтверждении готовности договора MTS');
      } finally {
        this.isLoading = false;
      }
    },
    
    resetMtsPhonePopup() {
      // Показываем индикатор загрузки
      this.isLoading = true;
      
      console.log('Сброс состояния попапа для повторной отправки');
      
      // Останавливаем таймер
      if (this.mtsPhoneTimer) {
        clearInterval(this.mtsPhoneTimer);
        this.mtsPhoneTimer = null;
      }
      
      // Используем $nextTick для гарантии обновления DOM
      this.$nextTick(() => {
        // Сбрасываем флаг (это отобразит форму ввода телефона)
        this.mtsSmsLinkSent = false;
        
        console.log('Флаг mtsSmsLinkSent сброшен в:', this.mtsSmsLinkSent);
        
        // Скрываем индикатор загрузки через небольшую задержку для лучшего UX
        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      });
    },
    
    reportMtsDataError() {
      this.mtsDataResetPopupVisible = true;
    },

    closeMtsDataResetPopup() {
      this.mtsDataResetPopupVisible = false;
    },

    async confirmMtsDataReset() {
      try {
        // Показываем индикатор загрузки
        this.isLoading = true;
        
        // Используем действие из Vuex
        await this.reportUserAccountError({
          btag: this.model.btag
        });

        this.mtsDataResetPopupVisible = false;
        this.mtsPassportFinalCheckPopupVisible = false;
        this.mtsPassportMatchPopupVisible = false;
        this.mtsPassportMatchPopupShown = false;

        if (this.mtsPhoneTimer) {
          clearInterval(this.mtsPhoneTimer);
          this.mtsPhoneTimer = null;
        }

        await this.getOrder({ btag: this.model.btag, loader: false });
        
        // Сбрасываем локальные поля
        this.lastname = '';
        this.firstname = '';
        this.patronymic = '';
        this.passport_number = '';
        this.passport_serial = '';
        
        // Обновляем clientInfo в store, сохраняя телефон для повторной ссылки
        this.CHANGE_CLIENT_INFO({
          lastname: '',
          firstname: '',
          patronymic: '',
          telefon: this.telefon,
          email: this.email,
          passport_number: '',
          passport_serial: ''
        });

        this.mtsPhoneNumber = this.telefon;
        
        // Показываем снова попап для ввода телефона
        this.showMtsPhonePopup();
      } catch (error) {
        console.error('Ошибка при отчетности об ошибке данных MTS:', error);
        this.setError('Ошибка при отчетности об ошибке данных MTS');
      } finally {
        this.isLoading = false;
      }
    },

    // Добавьте этот метод в раздел methods для правильной обработки номера телефона
    normalizePhoneNumber(phone) {
      // Просто удаляем все нецифровые символы
      return phone.toString().replace(/\D/g, '');
    },

    // Метод для форматирования номера для отображения
    formatPhoneForDisplay(phone) {
      // Просто добавляем + к цифрам
      const cleanPhone = phone.toString().replace(/\D/g, '');
      return '+' + cleanPhone;
    },
  }
}
</script>

<style lang="sass">
@import '@/styles/_vars.sass'

// Стили для глобального индикатора загрузки
.global-loading-overlay
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(255, 255, 255, 0.8)
  display: flex
  justify-content: center
  align-items: center
  z-index: 1000
</style>
